<template>
  <div v-if="this.$store.state.loggedIn" class="fixed-plugin">
    <div>
      <n-button type="secondary" round icon @click.native="showProfile">
        <i class="now-ui-icons business_badge"></i>
      </n-button>
    </div>
    <!-- BOTÓN VER NOTIFICACIONES RECIBIDAS -->
    <div v-if="this.nc > 0">
      <el-badge :value="this.nc" class="item">
        <n-button
          type="secondary"
          round
          icon
          @click.native="showNotification"
        >
          <i class="now-ui-icons ui-1_bell-53"></i>
        </n-button>
      </el-badge>
    </div>
    <div v-else>
      <n-button type="secondary" round icon>
        <i class="now-ui-icons ui-1_bell-53"></i>
      </n-button>
    </div>
    <div>
      <n-button type="secondary" round icon @click.native="showConfig">
        <i class="now-ui-icons loader_gear"></i>
      </n-button>
    </div>
    <div>
      <n-button type="secondary" round icon @click.native="exit" :title="$t('app.nav_bar.admin.account.close_session')">
        <i class="now-ui-icons arrows-1_share-66"></i>
      </n-button>
    </div>
    <!--n-button type="secondary" round icon @click.native="showCart">
      <i class="now-ui-icons shopping_cart-simple"></i>
    </n-button-->
    <profile />
    <notificaciones />
  </div>
</template>

<script>
export default {
  name: "SideTooltipMenu",
  components:{
    Profile: () => import("./web/components/profile"),
    Notificaciones: () => import("./web/components/notificaciones")
  },
  methods:{
    showProfile() {
      EventBus.$emit("show-profile");
    },
    showNotification() {
      //console.log("Notificaciones")
      EventBus.$emit("show-notification");
    },
    showCart() {
      EventBus.$emit("show-cart");
    },
    showConfig() {
      this.$router.push({
        name: "Configurar web"
      });
    },
    exit() {
      this.$router.push({
        name: "Logout"
      });
    }
  },
  computed:{
    nc() {
      return this.$store.state.not_count;
    }
  }
}
</script>

<style scoped>

</style>
